module.exports = __webpack_public_path__ + "images/category_lp/common/man_50_430f87db99449290ea8c446d7c900d1e.png";